import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {useMemo} from "react";

export const useGetGalllleryContexts = () => {

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'main',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'art',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/art`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/art`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'design',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/design`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/design`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'russian',
            linkTo: `${process.env.REACT_APP_URL_RUSSIAN_GALLERY}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_RUSSIAN_GALLERY}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'nature',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/nature`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/nature`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'history',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/history`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/history`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'retro',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/retro`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/retro`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'timeline',
            linkTo: `${process.env.REACT_APP_URL_GALLERY_TIMELINE}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY_TIMELINE}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: true,
            content: 'books',
            linkTo: `/`,
            action: () => {'/'},
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: '365',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/365`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/365`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'gallllery'
        }
    }
}import {ContextCodes} from "../../../pages/exploreHseContextsOldDeprecated/const/tabs";
import {useMemo} from "react";

export const useGetGalllleryContexts = () => {

    const links = useMemo(() => ([
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'main',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'art',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/art`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/art`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'design',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/design`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/design`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'russian',
            linkTo: `${process.env.REACT_APP_URL_RUSSIAN_GALLERY}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_RUSSIAN_GALLERY}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'nature',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/nature`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/nature`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'history',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/history`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/history`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'retro',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/retro`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/retro`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: 'timeline',
            linkTo: `${process.env.REACT_APP_URL_GALLERY_TIMELINE}`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY_TIMELINE}`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: true,
            content: 'books',
            linkTo: `/`,
            action: () => {'/'},
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
        {
            id: ContextCodes.hseDesignMain,
            active: false,
            content: '365',
            linkTo: `${process.env.REACT_APP_URL_GALLERY}/365`,
            action: () => {
                window.open(
                    `${process.env.REACT_APP_URL_GALLERY}/365`,
                    "_self"
                );
            },
            target: '_self',
            level: 1,
            hasChildren: true,
            hasCornerArrow: false,
        },
    ]), [])

    return {
        links,
        modalSettings: {
            titleColor: '#151514',
            title: 'gallllery'
        }
    }
}